// extracted by mini-css-extract-plugin
export default {"title-wrapper":"qqAh3","link":"dVihh","tariff":"ehRR1"};